// @ts-check
import Group from '@/store/modules/users/models/Group';

const Groups = Group.array();

export default Groups;
